import React from 'react';

const DocumentCheck: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 100 100" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.4"
      d="M22.134 34.325v41.601a2.214 2.214 0 002.18 2.181H55.76m15.103-23.862V22.312A2.183 2.183 0 0068.683 20H36.325"
    ></path>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.4"
      d="M22.134 34.323h12.011a2.18 2.18 0 002.181-2.181V20L22.134 34.323zm9.146 6.937h29.786m-29.949 5.99h14.909m-15.039 6.02h14.909m-15.04 6.022h14.942M42.51 35.24h18.555"
    ></path>
    <path
      fill="currentColor"
      d="M68.324 79.376a10.156 10.156 0 010-20.313 9.96 9.96 0 015.567 1.66 1.044 1.044 0 01.292 1.465 1.041 1.041 0 01-1.464.326 8.008 8.008 0 103.613 6.706 6.503 6.503 0 000-1.563 1.14 1.14 0 01.846-1.27 1.071 1.071 0 011.27.847 10.157 10.157 0 01-10.124 12.142z"
    ></path>
    <path
      fill="currentColor"
      d="M68.324 73.976a1.075 1.075 0 01-.846-.424l-4.07-5.631a1.074 1.074 0 01.261-1.497 1.041 1.041 0 011.498.227l3.255 4.525 8.528-10.123a1.075 1.075 0 111.628 1.4l-9.44 11.165a1.074 1.074 0 01-.814.358z"
    ></path>
  </svg>
);

export default DocumentCheck;
